// @ts-nocheck
import React, { useState, useEffect } from 'react';
import TreeSelect from '../ui/TreeSelect';
import { employeeApi } from '../../lib/api';
import notification from 'antd/lib/notification';
export default props => {
  const [rawData, setRawData] = useState([]);
  const [data, setData] = useState([]);
  const [value] = useState();
  const fetchData = async () => {
    try {
      const d = await employeeApi.fetchBranchEmployeesPositions(props.branchId);
      setRawData(d);
      const buildTree = data => {
        return data.reduce((result, employeeBranchPosition, ind) => {
          let index = result.findIndex(el => el.value === employeeBranchPosition.positionTitle);
          if (index === -1) {
            index = result.push({
              id: ind + 1,
              pId: 0,
              value: employeeBranchPosition.positionTitle,
              title: employeeBranchPosition.positionTitle || '',
              selectable: false
            }) - 1;
          }
          return result;
        }, []).sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : 0);
      };
      setData(buildTree(d));
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };
  const loadData = async node => {
    const fData = rawData.filter(el => el.positionTitle === node.props.title).map((el, index) => ({
      id: node.props.id * 1000 + index + 1,
      pId: node.props.id,
      value: el,
      title: `${el.positionTitle || ''}(${el.orgUnitName})`,
      isLeaf: true
    }));
    setData(data.concat(fData));
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);
  return <TreeSelect treeDataSimpleMode value={value} placeholder="Выберите должность" treeData={data} loadData={loadData} treeNodeFilterProp="title" showSearch allowClear {...props} />;
};
